
import {
    REPORT_MODAL_OPEN,
    REPORT_MODAL_CLOSE,
    GET_REPORT_MODAL_REASON_DATA,
    GET_REPORT_MODAL_REASON_DATA_SUCCESS,
    POST_REPORT,
    POST_REPORT_SUCCESS
} from '../constants/actionTypes';

export const reportModalOpen = payload => ({
    type: REPORT_MODAL_OPEN,
    payload
});

export const reportModalClose = () => ({
    type: REPORT_MODAL_CLOSE
});
export const getReportModalReasonData= () => ({
    type: GET_REPORT_MODAL_REASON_DATA
})

export const getReportModalReasonDataSuccess= payload => ({
    type: GET_REPORT_MODAL_REASON_DATA_SUCCESS,
    payload
})

export const postReport= payload => ({
    type: POST_REPORT,
    payload
})
export const postReportSuccess= () => ({
    type: POST_REPORT_SUCCESS
})